/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_SubtitleInputs */

const es_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecta. Busca. Encuentra. Un único punto de acceso para todo el conocimiento de tu empresa, potenciado por inteligencia artificial.`)
};

const en_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect. Search. Find. A single access point for all your company's knowledge, powered by artificial intelligence.`)
};

/**
* | output |
* | --- |
* | "Connect. Search. Find. A single access point for all your company's knowledge, powered by artificial intelligence." |
*
* @param {Home_Hero_SubtitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_hero_subtitle = /** @type {((inputs?: Home_Hero_SubtitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_SubtitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_hero_subtitle(inputs)
	return en_home_hero_subtitle(inputs)
});
export { home_hero_subtitle as "home.hero.subtitle" }